import React from "react";
import {observer} from "mobx-react-lite";
import {useMobileNavController, useRootStore} from "@stores/AppStateContext";

import {EditorHeader} from "./MobileHeaderElements/EditorHeader";
import {GeneralPageHeader} from "./MobileHeaderElements/GeneralPageHeader";
import {MainSidebarMobileHeader} from "./MobileHeaderElements/MainSidebarMobileHeader";
import {MobileRightMenuHeader} from "../RightMenu/MobileRightMenuHeader";
import {SettingsNavHeader} from "./MobileHeaderElements/SettingsNavHeader";

import {kbPages} from "../../../stores/ViewStore";


import './MobileHeader.css';


export const MobileHeader = observer(() => {
    const rootStore = useRootStore();
    const mobileNav = useMobileNavController();

    if (mobileNav.showMainSidebar) {
        return <MainSidebarMobileHeader/>;
    } if (mobileNav.showSettingsSecondary) {
        return <SettingsNavHeader/>;
    } if (mobileNav.showRightMenu) {
        return <MobileRightMenuHeader/>;
    } else if (kbPages.includes(rootStore.view.page as any)) {
        return <EditorHeader/>
    } else {
        return <GeneralPageHeader/>
    }
})
